const newslettersConfig = {
  angular: {
    action: '//facebook.us15.list-manage.com/subscribe/post?u=9e63a5f6d03e3654b1d10a323&amp;id=8c7f0ee4e1&GROUP=Angular',
    emailInputName: 'b_9e63a5f6d03e3654b1d10a323_8c7f0ee4e1',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Angular Typescript Trends</span> and get it before everyone else.',
  },
  golang: {
    action: 'https://facebook.us15.list-manage.com/subscribe/post?u=9e63a5f6d03e3654b1d10a323&amp;id=c67507e24b&GROUP=GoLang',
    emailInputName: 'b_9e63a5f6d03e3654b1d10a323_c67507e24b',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">GoLang Trends</span> and get it before everyone else.',
  },
  // android: {
  //   action: 'https://facebook.us15.list-manage.com/subscribe/post?u=9e63a5f6d03e3654b1d10a323&amp;id=534dab1b1d&GROUP=Android',
  //   emailInputName: 'b_9e63a5f6d03e3654b1d10a323_534dab1b1d',
  //   title: '',
  //   additionalTitle: 'Subscribe to our <span class="important">Android Trends</span> and get it before everyone else.',
  // },
  react: {
    action: 'https://facebook.us15.list-manage.com/subscribe/post?u=9e63a5f6d03e3654b1d10a323&amp;id=534dab1b1d&GROUP=React',
    emailInputName: 'b_9e63a5f6d03e3654b1d10a323_534dab1b1d',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">React Trends</span> and get it before everyone else.',
  },

  // other account  - teach.dor
  android: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][1]=1',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Android Trends</span> and get it before everyone else.',
  },
  kotlin: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][2]=2',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Kotlin Trends</span> and get it before everyone else.',
  }, 
  flutter: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][4]=4',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Flutter Trends</span> and get it before everyone else.',
  },
  vuejs: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][8]=8',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">VueJS Trends</span> and get it before everyone else.',
  }, 
  nodejs: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][16]=16',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">NodeJs Trends</span> and get it before everyone else.',
  },
  javascript: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][32]=32',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">JavaScript Trends</span> and get it before everyone else.',
  },
  typescript: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][64]=64',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">TypeScript Trends</span> and get it before everyone else.',
  },   
  graphql: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][128]=128',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">GraphQL Trends</span> and get it before everyone else.',
  },
  
  html: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][264]=264',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">HTML Trends</span> and get it before everyone else.',
  },
  css: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][528]=528',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">CSS Trends</span> and get it before everyone else.',
  },
  machinelearning: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][1024]=1024',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Machine Learning Trends</span> and get it before everyone else.',
  },
  php: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][2048]=2048',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">PHP Trends</span> and get it before everyone else.',
  },
  python: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][4096]=4096',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Python Trends</span> and get it before everyone else.',
  },
  java: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][8192]=8192',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Java Trends</span> and get it before everyone else.',
  },
  aws: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][16384]=16384',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">AWS Trends</span> and get it before everyone else.',
  },
  docker: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][32768]=32768',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Docker Trends</span> and get it before everyone else.',
  },
  ux: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][65536]=65536',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">UX Trends</span> and get it before everyone else.',
  },
  gamedev: {
    action: 'https://gmail.us17.list-manage.com/subscribe/post?u=ca2cab00b3981a84ae07bf160&amp;id=482435af5a&group[49929][131072]=131072',
    emailInputName: 'b_ca2cab00b3981a84ae07bf160_482435af5a',
    title: '',
    additionalTitle: 'Subscribe to our <span class="important">Game Development Trends</span> and get it before everyone else.',
  },      
};

export default {
  angular: newslettersConfig.angular,
  typescript: newslettersConfig.typescript,

  android: newslettersConfig.android,
  kotlin: newslettersConfig.kotlin,
  flutter: newslettersConfig.flutter,

  vuejs: newslettersConfig.vuejs,
  nodejs: newslettersConfig.nodejs,
  javascript: newslettersConfig.javascript,
  graphql: newslettersConfig.graphql,

  golang: newslettersConfig.golang,
  react: newslettersConfig.react,

  html: newslettersConfig.html,
  css: newslettersConfig.css,
  machinelearning: newslettersConfig.machinelearning,
  php: newslettersConfig.php,
  python: newslettersConfig.python,
  java: newslettersConfig.java,
  aws: newslettersConfig.aws,
  docker: newslettersConfig.docker,
  ux: newslettersConfig.ux,
  gamedev: newslettersConfig.gamedev,
};